import styles from './footer.module.scss';
import UpperBody from './upper-body';
import LowerBody from './lower-body';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

//footer component containing know us section and quick links section
const Footer = ({ hideEnquire = false, compact = false }) => (
  <footer className={`${styles.container} ${compact ? styles.compact : ''}`}>
    <div className={` ${hideEnquire ? '' : ''}`}>
      {!hideEnquire && <UpperBody />}
      <LowerBody />
    </div>
    <CopyRights />
  </footer>
);

Footer.propTypes = {
  hideEnquire: PropTypes.bool,
  compact: PropTypes.bool,
};

const CopyRights = () => {
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    setYear(currentYear);
  }, []);

  return (
    <div className={styles.copy__rights}>
      <div className={styles.copy__rights__text}>
        Copyright &copy; {year} Nepal Tourism Package Pvt. Ltd.
      </div>
    </div>
  );
};

export default Footer;
